import { Icon as BlueIcon } from '@blueprintjs/core';
import { getAssetMatchStatus } from '@components/AssetMatchLabel/AssetMatchLabel.utils';
import { EquipmentIdentificationStatus } from '@models/Equipment.model';
import {
  IdentificationText,
  // TooltipDiv,
  TooltipWraper,
} from './Sidebar.styles';

interface IdentificationStatusTooltipProps {
  identificationStatus: EquipmentIdentificationStatus | null;
}
export function IdentificationStatusTooltipBody(
  props: IdentificationStatusTooltipProps,
) {
  const { identificationStatus } = props;
  // const { isMobile } = useSelector(checkDevice());
  // Todo: Notify about disabled match changing
  // if (isMobile) {
  //   return (
  //     <Text text="b200" textColor="n0">
  //       To change a match, please visit this asset on your desktop.
  //     </Text>
  //   );
  // }
  const _status = getAssetMatchStatus(identificationStatus);
  if (_status === EquipmentIdentificationStatus.Unidentified) {
    return (
      <div>
        <TooltipWraper>
          <BlueIcon icon="error" color="#fff" size={12} />
          <IdentificationText className="tooltip">
            Unidentified
          </IdentificationText>
        </TooltipWraper>
        <IdentificationText className="tooltipSubtext">
          It was not possible to identify this product.
        </IdentificationText>
      </div>
    );
  }
  if (_status === EquipmentIdentificationStatus.Inventory) {
    return (
      <div>
        <TooltipWraper className="tooltipWraper">
          <BlueIcon icon="info-sign" color="#fff" size={12} />
          <IdentificationText className="tooltip">Internal</IdentificationText>
        </TooltipWraper>
        <IdentificationText className="tooltipSubtext">
          This product was identified as Internal.
        </IdentificationText>
      </div>
    );
  }
  if (_status === EquipmentIdentificationStatus.IdentificationRequested) {
    return (
      <div>
        <TooltipWraper className="tooltipWraper">
          <BlueIcon icon="history" color="#fff" size={12} />
          <IdentificationText className="tooltip">Requested</IdentificationText>
        </TooltipWraper>
        <IdentificationText className="tooltipSubtext">
          No action needed.
        </IdentificationText>
      </div>
    );
  }

  // Error  | Discarded | Identified
  return (
    <div>
      <TooltipWraper>
        <BlueIcon icon="tick-circle" color="#fff" size={12} />
        <IdentificationText className="tooltip">Identified</IdentificationText>
      </TooltipWraper>
      <IdentificationText className="tooltipSubtext">
        No action needed.
      </IdentificationText>
    </div>
  );
}
